<template>
	<div
		class="container-max"
		:class="{ 'login-my-account': myAccountInBacklink, 'login-checkout': !myAccountInBacklink }"
	>
		<div class="row pt-4" v-if="!myAccountInBacklink">
			<div
				class="col-12 col-md-8 col-lg-6 mx-auto bg-white login-switch-wrapper custom-border-radius custom-box-shadow p-4"
			>
				<div v-if="!hasAccount" id="new-customer">
					<span class="h4 mb-2 d-block">
						{{ $translate("Eros::Template.loginOrderAsGuest") }}</span>
					<div>
						<guest-check :backlink="sanitizedBacklink" :initial-email="guestEmail" @has-account="switchAuthMethod"></guest-check>
					</div>

					<div id="btn-separator" class="text-center my-5 position-relative">
						<hr />
						<span class="text-muted">
							{{ $translate("Eros::Template.loginExpressSeparator") }}</span>
					</div>

					<div class=" col-12 p-0">
						<span class="h4 text-body font-weight-bold">
							{{ $translate("Eros::Template.loginExpressCheckout") }}</span>
						<div class="text-center mt-3" id="AdditionalContentAfterButtons">
							<slot name="login-paypal-express-button"></slot>
							<div class="amazon-pay-button-wrapper" v-mutation-observer="{ id: 'fixAmzPayBtn' }">
								<div class="amazon-pay-button" data-color="Gold"></div>
							</div>
							<slot name="additional-content-after-buttons"></slot>
						</div>
					</div>
				</div>

				<div v-else class="mt-3" id="login-tab">
					<div class="row no-gutters">
						<button class="btn pt-0" :title="$translate('Eros::Template.mobileNavBack')" @click="resetCheck">
							<icon icon="chevron-left" />
						</button>
						<span class="h3">{{ $translate("Eros::Template.loginCustomerTab") }}</span>
					</div>
					<login :backlink="sanitizedBacklink" :has-to-forward="true" :initial-mail="initialLoginMail" @reset-check="resetCheck" :allow-guest-checkout="allowGuestCheckout"></login>
				</div>
			</div>
		</div>

		<div class="row" v-else>
			<div class="col-sm-10 offset-sm-1 col-md-6 offset-md-3">
				<h1 class="login-view-title mb-5">{{ $translate("Ceres::Template.login") }}</h1>
				<login :backlink="sanitizedBacklink" :has-to-forward="true"></login>
				<div class="row ">
					<div class="col-sm-12 mt-4 mb-4 text-center">
						<b class="h2">{{ $translate("Eros::Template.loginRegisterSeparator") }}</b>
					</div>
					<div class="col-sm-12">
						<a class="btn btn-primary btn-block mb-3" :href="registrationUrl">
							<i class="fa fa-user-plus" aria-hidden="true"></i>
							{{ $translate("Ceres::Template.loginRegister") }}
						</a>
					</div>
				</div>
			</div>
		</div>
		<div class="row">
			<div class="col-12 col-md-8 col-lg-6 mx-auto text-center my-3">
				<span id="ssl-hint" class="green mb-3"
					><i aria-hidden="true" class="fa fa-lock"></i>
					{{ $translate("Eros::Template.securedConnection") }}</span
				>
			</div>
		</div>
	</div>
</template>

<script>
import ValidationService from "../../../../ceres/services/ValidationService";
import GuestCheck from "./GuestCheck.vue";
import { mapGetters, mapActions } from "vuex";

export default {
	name: "login-check-view",

	components: {
		GuestCheck
	},

	props: {
		backlink: {
			type: String,
			default: ""
		},
		guestEmail: {
			type: String,
			default: ""
		},
		pluginPath: {
			type: String,
			default: ""
		},
		allowGuestCheckout: {
			type: Boolean,
			default: false
		}
	},

	data() {
		return {
			hasAccount: false,
			initialLoginMail: ""
		};
	},

	computed: {
		registrationUrl() {
			if (this.sanitizedBacklink !== "") {
				return App.urls.registration + "?backlink=" + this.sanitizedBacklink;
			}

			return App.urls.registration;
		},

		sanitizedBacklink() {
			return decodeURIComponent(this.backlink);
		},

		myAccountInBacklink() {
			return this.sanitizedBacklink.includes(App.urls.myAccount);
		},

		...mapGetters(["username", "isLoggedIn"])
	},

	methods: {
		unmarkInputFields() {
			ValidationService.unmarkAllFields($("#login"));
			ValidationService.unmarkAllFields($("#registration"));
		},

		openGuestModal() {
			this.$refs.guestModal.showModal();
		},

		createRegisterModal() {
			this.loadComponent("register-modal");
		},

		createLoginModal() {
			this.loadComponent("login-modal");
		},

		switchAuthMethod({ hasAccount, email }) {
			this.hasAccount = hasAccount;
			this.initialLoginMail = email;
		},

		resetCheck() {
			this.hasAccount = false;
			this.initialLoginMail = "";
		},

		...mapActions(["loadComponent"])
	}
};
</script>
